export interface ContractDesignFilter {
  consultantId?: string;
  contractNo?: string;
  jobName?: string;
  jobNumber?: string;
  schoolName?: string;
  statusId?: string;
}
